export enum CHART_QUERY_PARAM_NAME {
  BUCKET = 'bucket',
  LIVE_RANGE = 'live_range',
}


const hourName = '1h' as const;
const hour3Name = '3h' as const;
const hour6Name = '6h' as const;
const hour12Name = '12h' as const;
const hour24Name = '24h' as const;

export const TIME_RANGE_NAME = {
  HOUR: hourName,
  HOUR_3: hour3Name,
  HOUR_6: hour6Name,
  HOUR_12: hour12Name,
  HOUR_24: hour24Name,
};
